module.exports = __webpack_public_path__ + "static/img/1.ef17680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/huawei/1.png
// module id = Cs9X
// module chunks = 0